import { useAuth } from '../context/AuthContext'
import { Link, useNavigate } from 'react-router-dom'
import { usePageMeta } from '../hooks/usePageMeta'

const ADMIN_URL = typeof window !== 'undefined'
  ? `${window.location.protocol}//${window.location.hostname.replace('hub.', 'admin.')}`
  : '/admin'

export function MemberPage() {
  usePageMeta({
    title: 'Member',
    description: 'BNKR Mitgliederbereich.',
    canonical: '/member',
    noindex: true,
  })

  const { user, logout } = useAuth()
  const navigate = useNavigate()

  function handleLogout() {
    logout()
    navigate('/', { replace: true })
  }

  return (
    <div className="wrap" style={{ paddingTop: 'var(--sp-8)', paddingBottom: 'var(--sp-16)' }}>
      <div className="kicker crt" style={{ marginBottom: 12 }}>↳ /member · MEMBER AREA</div>
      <h1 className="display h2" style={{ marginTop: 0, marginBottom: 24 }}>
        Welcome, <span className="crt">{user?.fullName ?? user?.email}</span>
      </h1>

      <div className="member-area-grid">
        <div className="member-area-card">
          <div className="kicker" style={{ marginBottom: 8 }}>Admin Backend</div>
          <p style={{ color: 'var(--ink-2)', fontSize: 14, marginBottom: 16 }}>
            Zugang zum Admin-Dashboard: Events, Artists, Releases und mehr verwalten.
          </p>
          <Link to="/admin" className="btn btn-primary">
            Admin Dashboard →
          </Link>
        </div>

        <div className="member-area-card">
          <div className="kicker" style={{ marginBottom: 8 }}>Mein Account</div>
          <div className="stat-grid" style={{ marginBottom: 16 }}>
            <div>
              <div className="lbl">E-Mail</div>
              <div className="val">{user?.email}</div>
            </div>
            <div>
              <div className="lbl">Rolle</div>
              <div className="val">{(user?.role ?? '').toUpperCase()}</div>
            </div>
          </div>
          <button type="button" className="btn btn-crt" onClick={handleLogout}>
            Ausloggen
          </button>
        </div>
      </div>
    </div>
  )
}
